import { Application } from '@hotwired/stimulus';
import { definitionsFromContext } from '@hotwired/stimulus-webpack-helpers';

const application = Application.start();
const context = require.context('src/ui/controllers', true, /\.js$/);
application.load(definitionsFromContext(context));

document.addEventListener('turbo:before-cache', () => {
  application.controllers.forEach((controller) => {
    if (typeof controller.beforeCache === 'function') {
      controller.beforeCache();
    }
  });
});
